import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDefferedApprovals,
  fetchDefferedPayments,
  fetchDiscountPaymentsRequests,
  fetchImportMembersPendingApproval,
  fetchPT_DiscountPaymentLinks,
  fetchPT_DiscountPaymentsRequests,
} from "./paymentApiS";

export const fetchDefferedPaymentsData = createAsyncThunk(
  "payment/fetchDefferedPaymentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDefferedPayments(filters, token);
    return response;
  }
);

export const fetchImportMembersPendingApprovalData = createAsyncThunk(
  "payment/fetchImportMembersPendingApprovalData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchImportMembersPendingApproval(filters, token);
    return response;
  }
);

export const fetchDefferedApprovalsData = createAsyncThunk(
  "plans/fetchDefferedApprovalsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDefferedApprovals(filters, token);
    return response;
  }
);

export const fetchDiscountPaymentsData = createAsyncThunk(
  "payment/fetchDiscountPaymentsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDefferedPayments(filters, token);
    return response;
  }
);

export const fetchDiscountPaymentsRequestsData = createAsyncThunk(
  "payment/fetchDiscountPaymentsRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDiscountPaymentsRequests(filters, token);
    return response;
  }
);

export const fetchPT_DiscountPaymentsRequestsData = createAsyncThunk(
  "payment/fetchPT_DiscountPaymentsRequestsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPT_DiscountPaymentsRequests(filters, token);
    return response;
  }
);

export const fetchPT_DiscountPaymentLinksData = createAsyncThunk(
  "payment/fetchPT_DiscountPaymentLinksData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPT_DiscountPaymentLinks(filters, token);
    return response;
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    dfPaymentsData: null,
    dfPaymentsError: "",
    dfPaymentsLoading: false,

    importMemberPendingApproval: null,
    importMemberPendingApprovalLoading: false,
    importMemberPendingApprovalError: null,

    dfApprovals: null,
    dfApprovalsLoading: false,
    dfApprovalsError: null,

    discountPayments: null,
    discountPaymentsLoading: false,
    discountPaymentsError: null,

    discountPaymentRequests: null,
    discountPaymentRequestsLoading: false,
    discountPaymentRequestsError: null,

    ptDiscountPaymentRequests: null,
    ptDiscountPaymentRequestsLoading: false,
    ptDiscountPaymentRequestsError: null,

    ptDiscountPayments: null,
    ptDiscountPaymentsLoading: false,
    ptDiscountPaymentsError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDefferedPaymentsData.pending, (state) => {
        state.dfPaymentsLoading = true;
      })
      .addCase(fetchDefferedPaymentsData.fulfilled, (state, action) => {
        state.dfPaymentsLoading = false;
        state.dfPaymentsData = action.payload;
      })
      .addCase(fetchDefferedPaymentsData.rejected, (state, action) => {
        state.dfPaymentsLoading = false;
        state.dfPaymentsError = action.error.message;
      })

      .addCase(fetchImportMembersPendingApprovalData.pending, (state) => {
        state.importMemberPendingApprovalLoading = true;
      })
      .addCase(
        fetchImportMembersPendingApprovalData.fulfilled,
        (state, action) => {
          state.importMemberPendingApprovalLoading = false;
          state.importMemberPendingApproval = action.payload;
        }
      )
      .addCase(
        fetchImportMembersPendingApprovalData.rejected,
        (state, action) => {
          state.importMemberPendingApprovalLoading = false;
          state.importMemberPendingApprovalError = action.error.message;
        }
      )

      .addCase(fetchDefferedApprovalsData.pending, (state) => {
        state.dfApprovalsLoading = true;
      })
      .addCase(fetchDefferedApprovalsData.fulfilled, (state, action) => {
        state.dfApprovalsLoading = false;
        state.dfApprovals = action.payload;
      })
      .addCase(fetchDefferedApprovalsData.rejected, (state, action) => {
        state.dfApprovalsLoading = false;
        state.dfApprovalsError = action.error.message;
      })

      .addCase(fetchDiscountPaymentsData.pending, (state) => {
        state.discountPaymentsLoading = true;
      })
      .addCase(fetchDiscountPaymentsData.fulfilled, (state, action) => {
        state.discountPaymentsLoading = false;
        state.discountPayments = action.payload;
      })
      .addCase(fetchDiscountPaymentsData.rejected, (state, action) => {
        state.discountPaymentsLoading = false;
        state.discountPaymentsError = action.error.message;
      })

      .addCase(fetchDiscountPaymentsRequestsData.pending, (state) => {
        state.discountPaymentRequestsLoading = true;
      })
      .addCase(fetchDiscountPaymentsRequestsData.fulfilled, (state, action) => {
        state.discountPaymentRequestsLoading = false;
        state.discountPaymentRequests = action.payload;
      })
      .addCase(fetchDiscountPaymentsRequestsData.rejected, (state, action) => {
        state.discountPaymentRequestsLoading = false;
        state.discountPaymentRequestsError = action.error.message;
      })

      .addCase(fetchPT_DiscountPaymentsRequestsData.pending, (state) => {
        state.ptDiscountPaymentRequestsLoading = true;
      })
      .addCase(
        fetchPT_DiscountPaymentsRequestsData.fulfilled,
        (state, action) => {
          state.ptDiscountPaymentRequestsLoading = false;
          state.ptDiscountPaymentRequests = action.payload;
        }
      )
      .addCase(
        fetchPT_DiscountPaymentsRequestsData.rejected,
        (state, action) => {
          state.ptDiscountPaymentRequestsLoading = false;
          state.ptDiscountPaymentRequestsError = action.error.message;
        }
      )

      .addCase(fetchPT_DiscountPaymentLinksData.pending, (state) => {
        state.ptDiscountPaymentsLoading = true;
      })
      .addCase(fetchPT_DiscountPaymentLinksData.fulfilled, (state, action) => {
        state.ptDiscountPaymentsLoading = false;
        state.ptDiscountPayments = action.payload;
      })
      .addCase(fetchPT_DiscountPaymentLinksData.rejected, (state, action) => {
        state.ptDiscountPaymentsLoading = false;
        state.ptDiscountPaymentsError = action.error.message;
      });
  },
});

export default paymentSlice.reducer;
